import React from 'react'
import {HiOutlinePhotograph} from "react-icons/hi"
import { useDispatch } from "react-redux"
import {handleExportFunctionActivated, handleExportedImages, handleShowSaveUI} from "../../Redux/UIMenus/uiExportMenuSlice"

import "../../styles/ExportButton.css"

// Bottone del salvataggio file PDF
export default function ScreenShotButton() {
  const dispatch = useDispatch();

  const handleClick = () => {    
    // Elimina le immagini precedenti nel caso ce ne fossero
    dispatch(handleExportedImages([]));
    // Segnala di generare le immagini
    dispatch(handleExportFunctionActivated(true));  
    // Mostra la schermata di salvataggio
    dispatch(handleShowSaveUI(true));
  }

  return (
    <>          
        <button className="exportButton" onClick={handleClick}>
            <HiOutlinePhotograph size={"25px"}/>
            <p>SALVA</p>
            <p>PDF</p>
        </button>   
    </>
  )
}



